"use strict";

exports.__esModule = true;
exports.ImageFields = ImageFields;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
var _browserImageCompression = _interopRequireDefault(require("browser-image-compression"));
var _UI = require("../../../Utils/UI");
var _EnvContext = require("../../Env/EnvContext");
var _lodash = _interopRequireDefault(require("lodash.debounce"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Fields for ImageElement.
 */
function ImageFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  var _React$useContext = _react["default"].useContext(_EnvContext.EnvContext),
    imageInputMaxSizeInKB = _React$useContext.imageInputMaxSizeInKB;
  var convertFileToBase64 = function convertFileToBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function (event) {
        return resolve(event.target.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };
  var _useState = (0, _react.useState)(element.props.opacity || 100),
    opacity = _useState[0],
    setOpacity = _useState[1];
  var changeHandler = function changeHandler(value) {
    elementEditor.setProp(path, "opacity", value);
  };
  var debouncedChangeHandler = (0, _react.useCallback)((0, _lodash["default"])(changeHandler, 300), []);
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("ImageFields.selectImage.label", "Select image")
    }, /*#__PURE__*/_react["default"].createElement(_core.FileInput, {
      buttonText: translate("ImageFields.fileInput.buttonText", "Browse"),
      "data-testid": "ImageFields.fileInput.selector",
      text: translate("ImageFields.fileInput.text", "Choose image..."),
      accept: ".jpeg, .png, .jpg",
      onChange: (/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
          var imageFile, options, compressedFile, base64File, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                imageFile = event.target.files[0];
                if (!(imageFile.size > imageInputMaxSizeInKB * 1000)) {
                  _context.n = 1;
                  break;
                }
                (0, _UI.showWarningToaster)(translate("ImageFields.fileInput.incorrectImageSize.warning", "The maximum allowed image size is " + imageInputMaxSizeInKB / 1000 + "MB"));
                _context.n = 6;
                break;
              case 1:
                options = {
                  maxSizeMB: 1,
                  maxWidthOrHeight: 1920,
                  useWebWorker: true
                };
                _context.p = 2;
                _context.n = 3;
                return (0, _browserImageCompression["default"])(imageFile, options);
              case 3:
                compressedFile = _context.v;
                _context.n = 4;
                return convertFileToBase64(compressedFile);
              case 4:
                base64File = _context.v;
                elementEditor.setProp(path, "image", base64File);
                _context.n = 6;
                break;
              case 5:
                _context.p = 5;
                _t = _context.v;
                (0, _UI.showWarningToaster)(translate("ImageFields.fileInput.compressingFileError.warning", "Could not compress image"));
              case 6:
                return _context.a(2);
            }
          }, _callee, null, [[2, 5]]);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }())
    })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("ImageFields.selectImageOpacity.label", "Select image opacity")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "ImageFields.selectImageOpacity.input"
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      min: 0,
      max: 100,
      stepSize: 1,
      labelStepSize: 100,
      onChange: function onChange(value) {
        setOpacity(value);
        debouncedChangeHandler(value);
      },
      value: opacity,
      labelRenderer: function labelRenderer(value) {
        return value + "%";
      }
    }))), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("ImageFields.selectImageFit.label", "Select image fit type"),
      helperText: translate("ImageFields.selectImageFit.helperText", "The type of fitting image in a widget")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.HTML_SELECT,
      "data-testid": "ImageFields.imageFitType.buttonSelector"
    }, /*#__PURE__*/_react["default"].createElement("select", {
      value: element.props.imageFit || "",
      "data-testid": "ImageFields.imageFitType.selector",
      onChange: function onChange(e) {
        elementEditor.setProp(path, "imageFit", e.target.value);
      }
    }, /*#__PURE__*/_react["default"].createElement("option", {
      value: "cover",
      "data-testid": "ImageFields.imageFitType.cover"
    }, translate("ImageFields.imageFitType.cover.label", "Cover")), /*#__PURE__*/_react["default"].createElement("option", {
      value: "contain",
      "data-testid": "ImageFields.imageFitType.contain"
    }, translate("ImageFields.imageFitType.contain.label", "Contain")), /*#__PURE__*/_react["default"].createElement("option", {
      value: "fill",
      "data-testid": "ImageFields.imageFitType.fill"
    }, translate("ImageFields.imageFitType.fill.label", "Fill")), /*#__PURE__*/_react["default"].createElement("option", {
      value: "none",
      "data-testid": "ImageFields.imageFitType.none"
    }, translate("ImageFields.imageFitType.none.label", "None")), /*#__PURE__*/_react["default"].createElement("option", {
      value: "scale-down",
      "data-testid": "ImageFields.imageFitType.scaleDown"
    }, translate("ImageFields.imageFitType.scaleDown.label", "Scale down"))))));
  });
}